// extracted by mini-css-extract-plugin
export var attachment = "_o2-a";
export var emailContainer = "_o2-4";
export var emailContentPaddedContainer = "_o2-b";
export var emailHeader = "_o2-6";
export var emailIframe = "_o2-3";
export var emailInfoIcon = "_o2-9";
export var emailShortenedSummary = "_o2-e";
export var infoDropdown = "_o2-0";
export var infoRowBoundedContent = "_o2-d";
export var internal = "_o2-5";
export var merchant = "_o2-8";
export var messageInputContainer = "_o2-h";
export var normal = "_o2-7";
export var replyCard = "_o2-f";
export var subtleButton = "_o2-1";
export var subtleButtonIconContainer = "_o2-2";
export var toggleViewRepliesButton = "_o2-c";
export var wrappingText = "_o2-g";